// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/ViewBids.scss
// module id = ./src/styles/ViewBids.scss
// module chunks = 0